import { render, staticRenderFns } from "./GLPostAcct.vue?vue&type=template&id=2dcaa6d1&"
import script from "./GLPostAcct.vue?vue&type=script&lang=js&"
export * from "./GLPostAcct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports